import { Component, OnInit, Input } from '@angular/core';

import { Grouping } from '@classes/grouping/grouping';

@Component({
    selector: 'app-report-sample',
    templateUrl: './report-sample.component.html',
    styleUrls: ['./report-sample.component.scss']
})
export class ReportSampleComponent implements OnInit {
    @Input() group: Grouping;

    isComplete: boolean = null;
    constructor( ) { }

    ngOnInit() {
    }
}
